import React from 'react';
import { Modal, Form, DatePicker, Button, message, notification } from 'antd';
import dayjs from 'dayjs';
import { useFreezeAddonMutation } from '../../../services/membership';
import './styles.scss';

const FreezeAddonModal = ({ visible, onCancel, selectedMembership }) => {
  const [form] = Form.useForm();
  const [freezeAddon, { isLoading: freezing }] = useFreezeAddonMutation();

  const onFinishFailed = ({ errorFields }) => {
    if (!errorFields?.length) return;
    const labels = errorFields.map(f => {
      const name = Array.isArray(f.name) ? f.name[0] : f.name;
      return String(name).replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    });
    const unique = [...new Set(labels)];
    notification.error({
      message: 'Required Fields Missing',
      description: unique.join(', '),
      placement: 'topRight',
      duration: 4,
    });
  };

  const handleSubmit = async (values) => {
    try {
      await freezeAddon({
        membershipId: selectedMembership?._id,
        startDate: values.startDate.format('YYYY-MM-DD'),
        endDate: values.endDate.format('YYYY-MM-DD'),
      }).unwrap();
      message.success('Add-on frozen successfully');
      form.resetFields();
      onCancel();
    } catch {
      /* error toast handled globally by badRequestHandler */
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Freeze Add-On Service"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={500}
      className="freeze-addon-modal"
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          name="startDate"
          label="Start Date"
          rules={[{ required: true, message: 'Please select start date' }]}
        >
          <DatePicker
            style={{ width: '100%' }}
            format="DD/MM/YYYY"
            disabledDate={(current) => !!current && current < dayjs().startOf('day')}
          />
        </Form.Item>

        <Form.Item
          name="endDate"
          label="End Date"
          rules={[{ required: true, message: 'Please select end date' }]}
        >
          <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
        </Form.Item>

        <Form.Item>
          <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
            <Button onClick={handleCancel}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" loading={freezing}>
              Submit Freeze Request
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FreezeAddonModal;
